<!-- <button (click)="check()">check</button> -->
<div #isometricDrawingContainer id="isometricDrawingContainer" style="height: 100vh;"></div>
